<app-esqueleto-tableros [filterWidth]="250">
  <div titulo class="encabezadosSeparacion"
  [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
  [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)"
    [icono]="'calendar_month'"
    [click]="false"
  />

  <div contenido class="contenido">
    <app-contenedor-elementos [header]="header" class="zona1 w3-scroll">
      <mat-icon iconos class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
      [matMenuTriggerFor]="menuTable">
        more_vert
      </mat-icon>
      <div body class="tablaGap w3-scroll">
        @if(verTabla){
          <table class="tabla-aleema">
            <thead>
              <tr>
                @if (tablaConfig) {
                  @for (encabezados of tablaConfig.columnas; track encabezados ;let i = $index) {
                    <th [ngClass]="{'sticky-column':i===0}">
                      {{encabezados}}
                    </th>
                  }
                }
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (tablaConfig) {
                @for (fila of tablaConfig.filas; track $index) {
                  @if (fila.visible && fila.type !== 'titulo' && fila.type !== 'blank') {
                    <tr>
                      <td class="sticky-column" style="white-space: pre;"
                      [ngClass]="{'total': fila.type === 'subtotal' || fila.suma}">
                        @if (fila.expandible){
                          <mat-icon class="iconoMen" (click)="showAndHide(fila)">
                            {{fila.expandido?'expand_less':'expand_more'}}
                          </mat-icon>
                        }
                        {{fila.descripcion}}
                      </td>
                      @for (banda of fila.bandasValue; track $index) {
                        <td class="alinRight"
                        [ngClass]="{
                          'bordersNoLaterales': banda === null,
                          'total': fila.type === 'subtotal' || fila.suma
                        }">
                          {{banda | formaterNumber:fila.decimales??0:',':'.'}}
                        </td>
                      }
                      <td class="alinRight total">
                        @if (fila.total || fila.total === 0) {
                          {{fila.total | formaterNumber:fila.decimales??0:',':'.'}}
                        }
                      </td>
                      <td class="total">
                        @if (fila.comparacion) {
                          @if (fila.total!==fila.valorComparacion) {
                            <span style="margin-right: 5%;">
                              <mat-icon class="iconoMen" [customTooltip]="tooltipTemplate">info_outline</mat-icon>
                            </span>
                          }@else if (fila.total!==fila.valorComparacion) {
                            <span style="margin-right: 5%;">
                              <mat-icon class="iconoMen">done</mat-icon>
                            </span>
                          }
                          <ng-template #tooltipTemplate>
                            <div class="w3-row"> 
                              <div class="w3-row"> <strong> Los valores difieren </strong> </div>
                              <div class="w3-row alinCenter">
                                BDD: {{fila.total | formaterNumber:0:',':'.'}} <br> AT: {{ fila.valorComparacion | formaterNumber:0:',':'.' }}
                              </div>
                            </div>
                          </ng-template>
                        }
                        @if (fila.ingresoManual) {
                          <mat-icon (click)="openModal(fila)" class="iconoMen">edit</mat-icon>
                        }
                      </td>
                    </tr>
                  }@else if(fila.type === 'titulo'){
                    <tr class="sticky-column">
                      <td class="w3-elemento-titulo-table" [colSpan]="(fila.bandas.length+3)">
                        {{fila.descripcion}}
                      </td>
                    </tr>
                  }@else if(fila.type === 'blank'){
                    <tr style="height: 15px;">
                      <td [colSpan]="(fila.bandas.length+3)">
                      </td>
                    </tr>
                  }
                }
              }
            </tbody>
          </table>
        }@else{
          <app-skeleton-table/>
        }
      </div>
    </app-contenedor-elementos>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal" (close)="closeModal()">
  <div modal-header>
    {{filaEdit?.name}}
  </div>

  <div modal-body>
    <table class="w3-table">
      <tbody>
        @for (ban of bandas; track ban; let i = $index) {
          <tr class="allBordes">
            <th class="stikyColum textoOverFlow w3-elemento-titulo-table allBordes"
                style="width: 50%; padding: 0 10px">
              <span>
                {{ (idPlantilla === 7 ? 'liquidez.gap.' + ban : ban) | translate }}
              </span>
            </th>
            <td class="alinCenter"
                style="padding: 0px">
              @if (bandasValues[i] !== null && bandasValues[i] !== undefined) {
                <div style="padding: 0px">
                  <input
                    id="{{ 'valor' + i }}"
                    matInput
                    [disabled]="edit"
                    class="inputTable"
                    [(ngModel)]="bandasValues[i]"
                    (ngModelChange)="actualizarBanda(i, $event)"
                    (focus)="seleccionarCero($event)"
                    currencyMask
                    [options]="{
                      thousands: ',',
                      decimal: '.',
                      precision: 0,
                      nullable: false,
                      aling: 'center',
                      prefix: ''
                    }">
                </div>
              }
            </td>
          </tr>
        }
        <tr class="allBordes">
          <th class="stikyColum textoOverFlow w3-elemento-titulo-table allBordes"
              style="width: 50%; padding: 0 10px ">
            <span>
              {{ 'liquidez.gap.tituloTabla2' | translate }}
            </span>
          </th>
          <td class="alinCenter"
              style="width: 50%; padding: 0;">
            <input
              matInput
              [disabled]="true"
              class="inputTable"
              [value]="totalPorcen"
              currencyMask
              [options]="{
                thousands: ',',
                decimal: '.',
                precision: 0,
                aling: 'center',
                prefix: ''
              }">
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  @if (edit) {
    <app-button modal-footer
      [icon]="'edit'"
      [color]="'#fff'"
      (click)="edit = false"
    />
  } @else {
    <div modal-footer class="contenedorFooter" style="width: 100%;">
      <div class="leyenda" style="font-size: 0.6rem;">
        <mat-icon class="iconoL">
          info_outline
        </mat-icon>
        Haz click en la 
        <mat-icon class="iconoL">
          done
        </mat-icon>
        para guardarlos datos
      </div>

      <mat-icon class="iconoL buttonPal"
        style="color: #ff6b00; cursor: pointer;"
        (click)="guardarVariables()">
        done
      </mat-icon>
    </div>
  }
</app-modal>

<mat-menu #menuTable="matMenu">
  <!-- <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="formN">
    <span>{{moneda}}/Miles</span>
  </button> -->
  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
  (click)="exportExcel()">
    <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
    <span>{{'menu.Exportar'|translate}}</span>
  </button>
</mat-menu>